enum LoggedPage {
  Assistant = 'Assistant',
  Courses = 'Courses',
}

export default LoggedPage;
